import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { KEY_PREFIX } from 'marketplace-ui-common/hooks/useSearchParams';
import { getIsPrerenderUserAgent } from 'marketplace-ui-common/utils/userAgent';
import { Redirect, useLocation } from 'quartz-routing/react-router';
import { useMemo } from 'react';
import { StorefrontPageMetadata } from '../../components/StorefrontPageMetadata';
import { Paths } from '../../constants/paths';
import { Subscreens } from '../../constants/usage';
import { ListingDetailsContainer } from '../../containers/ListingDetails';
import { useFilterConfigData } from '../../filters/hooks/useFilterConfig';
import { useTrackProxyRedirect } from '../../hooks/useTrackProxyRedirect';
import { getFullPublicUrl } from '../../utils/urls';
import { useParsedSearchResultsPathParams } from '../hooks/useParsedSearchResultsPathParams';
import { jsx as _jsx } from "react/jsx-runtime";
function matchSlug(slug, filter) {
  const match = filter === null || filter === void 0 ? void 0 : filter.options.find(o => o.slug === slug);
  return match ? {
    field: String(filter.field),
    value: String(match.value)
  } : undefined;
}
export function SolutionsPartnersSearchResultsProxy() {
  var _data$result, _data$result2, _data$result3;
  const parsedPathParams = useParsedSearchResultsPathParams();
  const location = useLocation();
  const {
    data,
    loading
  } = useFilterConfigData();
  const PROFILE_CATALOG_SERVICES = data === null || data === void 0 || (_data$result = data.result) === null || _data$result === void 0 || (_data$result = _data$result.filterConfigs) === null || _data$result === void 0 ? void 0 : _data$result.PROFILE_CATALOG_SERVICES;
  const PROFILE_INDUSTRIES = data === null || data === void 0 || (_data$result2 = data.result) === null || _data$result2 === void 0 || (_data$result2 = _data$result2.filterConfigs) === null || _data$result2 === void 0 ? void 0 : _data$result2.PROFILE_INDUSTRIES;
  const PROFILE_LOCATION_COUNTRY = data === null || data === void 0 || (_data$result3 = data.result) === null || _data$result3 === void 0 || (_data$result3 = _data$result3.filterConfigs) === null || _data$result3 === void 0 ? void 0 : _data$result3.PROFILE_LOCATION_COUNTRY;
  const {
    params,
    isProfilePage,
    subscreen,
    filters,
    filterType,
    filterValue
  } = useMemo(() => {
    var _ref, _matchSlug;
    if (loading) {
      return {
        params: new URLSearchParams(),
        isProfilePage: false,
        subscreen: '',
        filters: [],
        filterType: undefined,
        filterValue: undefined
      };
    }
    const urlParams = new URLSearchParams(location.search);
    if (parsedPathParams.page) {
      urlParams.set(`${KEY_PREFIX}page`, parsedPathParams.page.toString());
    }

    // The category slug is matched against service (e.g. "implementation"),
    // industry (e.g. "technology"), or country (e.g. "united-states")
    // filter options. A matched slug sets the corresponding search param:
    //   /solutions/implementation → ?eco_PROFILE_CATALOG_SERVICES=IMPLEMENTATION
    //   /solutions/leadstreet → no match, falls back to profile page
    const {
      categorySlug
    } = parsedPathParams;
    if (!categorySlug) {
      return {
        params: urlParams,
        isProfilePage: false,
        subscreen: Subscreens.PROXY_ALL_SOLUTIONS_PARTNERS,
        filters: [],
        filterType: undefined,
        filterValue: undefined
      };
    }
    const match = (_ref = (_matchSlug = matchSlug(categorySlug, PROFILE_CATALOG_SERVICES)) !== null && _matchSlug !== void 0 ? _matchSlug : matchSlug(categorySlug, PROFILE_INDUSTRIES)) !== null && _ref !== void 0 ? _ref : matchSlug(categorySlug, PROFILE_LOCATION_COUNTRY);
    if (!match) {
      return {
        params: urlParams,
        isProfilePage: true,
        subscreen: '',
        filters: [],
        filterType: undefined,
        filterValue: undefined
      };
    }
    urlParams.set(`${KEY_PREFIX}${match.field}`, match.value);
    return {
      params: urlParams,
      isProfilePage: false,
      subscreen: Subscreens.PROXY_SOLUTIONS_CATEGORY,
      filters: [match.field],
      filterType: match.field,
      filterValue: [match.value]
    };
  }, [PROFILE_CATALOG_SERVICES, PROFILE_INDUSTRIES, PROFILE_LOCATION_COUNTRY, loading, location.search, parsedPathParams]);
  useTrackProxyRedirect({
    filterType,
    filterValue,
    filters,
    loading,
    pageNumber: parsedPathParams.page,
    skip: !subscreen,
    subscreen,
    type: 'SOLUTIONS_PARTNER_PROFILE'
  });
  if (loading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      size: "medium",
      marginBlockStart: "1600"
    });
  }
  if (isProfilePage) {
    return /*#__PURE__*/_jsx(ListingDetailsContainer, {});
  }
  const search = params.toString();
  if (getIsPrerenderUserAgent()) {
    return /*#__PURE__*/_jsx(StorefrontPageMetadata, {
      prerenderStatusCode: 301,
      prerenderHeaders: {
        Location: getFullPublicUrl(`${Paths.SEARCH_RESULTS_SOLUTIONS_PARTNERS}${search ? `?${search}` : ''}`)
      }
    });
  }
  return /*#__PURE__*/_jsx(Redirect, {
    to: {
      pathname: Paths.SEARCH_RESULTS_SOLUTIONS_PARTNERS,
      search: search ? `?${search}` : ''
    }
  });
}